export default {
    title: null,
    target: null,
    unitOfMeasurement: null,
    weight: null,
    activePeriod: null,
    owner: null,
    initialValue: null,
    yearToDate: null,
    level: null,
    section: null,
    description: null,
    rangesOfPerformance: null,
    polarity: null,
}
